import angular from 'angular';

class DataTable {
	constructor(moment, $rootScope) {
		this.moment     = moment;
		this.$rootScope = $rootScope;

		this.state = {};
	}

	setId(id) {
		this.state.id = id;

		return this;
	}

	setTitle(title) {
		this.state.title = title;

		return this;
	}

	setDom(dom) {
		this.state.dom = dom;

		return this;
	}

	setButtons(buttons) {
		this.state.buttons = buttons;

		return this;
	}

	setPageLength(pageLength) {
		this.state.pageLength = pageLength;

		return this;
	}

	setPageLengthMenu(pageLengthMenu) {
		this.state.pageLengthMenu = pageLengthMenu;

		return this;
	}

	setEmptyTableMessage(message) {
		this.state.emptyTableMessage = message;

		return this;
	}

	setTotalsColumns(totalsColumns) {
		this.state.totalsColumns = totalsColumns;

		return this;
	}

	setFixedHeader(fixedHeader) {
		this.state.fixedHeader = fixedHeader;

		return this;
	}

	setFrozenColumns(frozenColumns) {
		this.state.frozenColumns = frozenColumns;

		return this;
	}

	setReorderableColumns(reorderableColumns) {
		this.state.reorderableColumns = reorderableColumns;

		return this;
	}

	getConfiguration(options, columnDefs) {
		let conditionalOptions = {};

		if (this.state.frozenColumns) {
			conditionalOptions.scrollX      = true;
			conditionalOptions.fixedColumns = {
				leftColumns:  0, //options.frozenLeftColumns || 0,
				rightColumns: 0, //options.frozenRightColumns || 0,
			};
		}

		if (this.state.reorderableColumns) {
			conditionalOptions.colReorder = {
				realtime:          false,
				fixedColumnsLeft:  0, //options.frozenLeftColumns || 0,
				fixedColumnsRight: 0, //options.frozenRightColumns || 0,
			};
		}

		let configuration = {
			id:         this.state.id,
			totals:     {
				id:          this.state.id,
				lastUpdated: 0,
				columns:     this.state.totalsColumns,
				page:        {},
				total:       {},
			},
			options:    {
				dom:            this.state.dom,
				buttons:        this.state.buttons,
				lengthMenu:     this.state.pageLengthMenu,
				pageLength:     this.state.pageLength,
				language:       {
					emptyTable: this.state.emptyTableMessage,
				},
				// fixedHeader:    this.state.fixedHeader,
				footerCallback: null,
				...conditionalOptions,
				...options,
			},
			columnDefs: {
				...columnDefs,
			},
		};

		configuration.options.footerCallback = (row, data, start, end, display) => {
			angular.forEach(configuration.totals.columns, (value, key) => {
				configuration.totals.page[key]  = 0.0;
				configuration.totals.total[key] = 0.0;
			});

			angular.forEach(display, (rowKey, index) => {
				const row = data[rowKey];

				angular.forEach(configuration.totals.columns, (columnValue, columnKey) => {
					let number = parseFloat(row[columnValue].replace(/<(?:.|\n)*?>/gm, '')
					                                        .replace(/\$|,/g, ''));

					if (isNaN(number)) {
						number = 0.0;
					}

					configuration.totals.total[columnKey] += number;

					if (data.length === display.length) {
						if (start <= index && index < end) {
							configuration.totals.page[columnKey] += number;
						}
					} else {
						if (display.indexOf(rowKey) !== -1) {
							configuration.totals.page[columnKey] += number;
						}
					}
				});
			});

			// This is not always consistently detected by the dtFooter directive
			configuration.totals.lastUpdated = this.moment()
			                                       .format('x');

			// So broadcast instead
			this.$rootScope.$broadcast('dataTablesService.updated', configuration.id);
		};

		return configuration;
	}
}

/* @ngInject */
class DataTables {
	static domWithButtons = '<\'row\'<\'col-sm-3\'l><\'col-sm-9\'Bf>><\'row\'<\'col-sm-12\'<\'overflow-x\'tr>>><\'row\'<\'col-sm-5\'i><\'col-sm-7\'p>>';
	static dom            = '<\'row\'<\'col-sm-3\'l><\'col-sm-9\'f>><\'row\'<\'col-sm-12\'<\'overflow-x\'tr>>><\'row\'<\'col-sm-5\'i><\'col-sm-7\'p>>';

	constructor(_, $rootScope, moment, uuid) {
		this._          = _;
		this.$rootScope = $rootScope;
		this.moment     = moment;
		this.uuid       = uuid;

		this.listeners = [];
	}

	buttons(title) {
		return [
			{
				extend:        'copy',
				text:          'Copy',
				exportOptions: {
					columns: ':visible',
				},
			},
			{
				extend:        'csv',
				text:          'CSV',
				title:         title,
				exportOptions: {
					columns: ':visible',
				},
			},
			{
				extend:        'excel',
				text:          'Excel',
				title:         title,
				exportOptions: {
					columns: ':visible',
				},
			},
			{
				extend:        'pdf',
				text:          'PDF',
				title:         title,
				exportOptions: {
					columns: ':visible',
				},
			},
			{
				extend:        'print',
				text:          'Print',
				title:         title,
				exportOptions: {
					columns: ':visible',
				},
			},
		];
	}

	configure(settings, options, columnDefs) {
		let configuration = {
			id:                 this.uuid.v4(),
			title:              'Report',
			dom:                (settings.hideButtons) ? (DataTables.dom) : (DataTables.domWithButtons),
			pageLength:         25,
			pageLengthMenu:     [
				[
					10,
					25,
					50,
					100,
					-1,
				],
				[
					10,
					25,
					50,
					100,
					'All',
				],
			],
			emptyTableMessage:  'No matching records found.',
			totalsColumns:      {},
			fixedHeader:        true,
			toggleableColumns:  true,
			frozenColumns:      false,
			reorderableColumns: false,
			...settings,
		};

		if (configuration.dom === DataTables.domWithButtons) {
			configuration.buttons = this.buttons(configuration.title);
		}

		if (configuration.toggleableColumns) {
			configuration.buttons = [
				...configuration.buttons,
				{
					extend: 'colvis',
					text:   'Toggle Columns',
				},
			];
		}

		if (false && configuration.frozenColumns) {
			configuration.buttons = [
				...configuration.buttons,
				{
					text:   'Frozen Columns',
					action: function (e, dt, node, config) {
						let columns = [];

						dt.table()
						  .columns()
						  .every(function () {
							  columns.push(this.header().innerText);
						  });
					},
				},
			];
		}

		if (configuration.additionalButtons) {
			configuration.buttons = [
				...configuration.buttons,
				...configuration.additionalButtons,
			];
		}

		if (settings.buttonsCallback) {
			configuration.buttons = settings.buttonsCallback(configuration.buttons);
		}

		let table = new DataTable(this.moment, this.$rootScope);

		table.setId(configuration.id)
		     .setTitle(configuration.title)
		     .setDom(configuration.dom)
		     .setButtons(configuration.buttons)
		     .setPageLength(configuration.pageLength)
		     .setPageLengthMenu(configuration.pageLengthMenu)
		     .setEmptyTableMessage(configuration.emptyTableMessage)
		     .setTotalsColumns(configuration.totalsColumns)
		     .setFixedHeader(configuration.fixedHeader)
		     .setFrozenColumns(configuration.frozenColumns)
		     .setReorderableColumns(configuration.reorderableColumns);

		return table.getConfiguration(options, columnDefs);
	}

	fireUpdatedEvent(table) {
		this.$rootScope.$broadcast('dataTablesService.updated', table);
	}

	dateColumns(total, dates) {
		let columns = [];

		for (let i = 0; i < total; i++) {
			columns.push({});
		}

		angular.forEach(dates, (date) => {
			let display = date[0];
			let sort    = date[1];

			columns[display] = {
				aTargets:  display,
				orderData: sort,
			};

			columns[sort] = {
				aTargets:  sort,
				bVisible:  false,
				bSortable: false,
			};
		});

		return columns;
	}
}

export default DataTables;


// WEBPACK FOOTER //
// ./src/js/services/dataTables/index.js